import React from 'react';
import PropTypes from 'prop-types';
import styles from './AthleteGroupItem.module.css';

const AthleteGroupItem = ({
  athlete,
  isSelected = false,
  isDisabled = false,
  onAdd,
  onRemove,
  showAddButton = true,
  showRemoveButton = false,
  variant = 'available', // 'available' or 'selected'
}) => {
  const handleClick = () => {
    if (isDisabled) return;

    if (variant === 'available' && !isSelected && onAdd) {
      onAdd(athlete);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove(athlete.athleteID);
    }
  };

  const getDisplayName = () => {
    if (athlete.firstName && athlete.lastName) {
      return `${athlete.firstName} ${athlete.lastName}`;
    }
    return athlete.name || 'Unknown Athlete';
  };

  const getDisplayNumber = () => {
    const number = athlete.clubAthleteNumber;
    return number ? String(number) : '';
  };

  const getDisplayDetails = () => {
    const parts = [];
    if (athlete.ageGroup) parts.push(String(athlete.ageGroup));
    if (athlete.gender) {
      parts.push(athlete.gender === 'M' ? 'Male' : 'Female');
    }
    if (athlete.age) parts.push(`Age ${athlete.age}`);
    return parts.join(' • ');
  };

  return (
    <div
      className={`${styles.athleteItem} ${isSelected ? styles.selected : ''} ${isDisabled ? styles.disabled : ''}`}
      onClick={handleClick}
    >
      <div className={styles.athleteInfo}>
        <div className={styles.athleteName}>
          {getDisplayName()} {getDisplayNumber() && `(#${getDisplayNumber()})`}
        </div>
        <div className={styles.athleteDetails}>{getDisplayDetails()}</div>
      </div>

      <div className={styles.athleteActions}>
        {isSelected && variant === 'available' && (
          <span className={styles.alreadySelectedBadge}>Selected</span>
        )}

        {!isSelected && showAddButton && variant === 'available' && (
          <button
            className={styles.addButton}
            onClick={(e) => {
              e.stopPropagation();
              onAdd(athlete);
            }}
          >
            Add
          </button>
        )}

        {showRemoveButton && variant === 'selected' && (
          <button className={styles.removeButton} onClick={handleRemove}>
            Remove
          </button>
        )}
      </div>
    </div>
  );
};

AthleteGroupItem.propTypes = {
  athlete: PropTypes.shape({
    athleteID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    name: PropTypes.string,
    athleteNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ageGroup: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    gender: PropTypes.string,
    age: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  showAddButton: PropTypes.bool,
  showRemoveButton: PropTypes.bool,
  variant: PropTypes.oneOf(['available', 'selected']),
};

export default AthleteGroupItem;
